import styled from '@emotion/styled'
import { tokens } from '../../theme.js'
import { WhiteCard, FlexRow, MedBodyText } from '../../components/styles/index.js'

const colors = tokens.colors

export const BillingContent = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 32px 40px;
  box-sizing: border-box;
`

export const BillingHeader = styled(FlexRow)`
  align-items: baseline;
`

export const BillingSubtitle = styled(MedBodyText)`
  color: ${colors.inputField.placeholder};
  margin-top: 4px;
`

export const BillingCard = styled(WhiteCard)`
  padding: 24px;
`

export const BillingSplitCard = styled(BillingCard)`
  flex: 1;
`

export const BillingTotal = styled.div`
  font: 700 40px/1.1 ${tokens.fonts.body};
  color: ${colors.text.heading};
  margin-top: 6px;
`

export const BillingBarTrack = styled.div`
  height: 8px;
  background: ${colors.background.medium};
  border-radius: 4px;
  overflow: hidden;
`

export const BillingBarFill = styled.div`
  width: ${props => `${Math.max(2, props.$fraction * 100)}%`};
  height: 100%;
  background: ${colors.primary};
`

export const BillingSkeleton = styled.div`
  height: ${props => `${props.$height}px`};
  border-radius: ${tokens.borderRadius.div};
  background: ${colors.background.medium};
  opacity: 0.6;
`

export const BillingRow = styled(FlexRow)`
  justify-content: space-between;
`

export const BillingCategoryRow = styled(BillingRow)`
  margin-bottom: 4px;
`

export const BillingPanels = styled(FlexRow)`
  align-items: stretch;
`

export const BillingTenantName = styled(MedBodyText)`
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
